import styled from "styled-components";

export const WrapperLayout = styled.section`
  margin: 16px;
`;

export const Title = styled.h1`
  margin: 10px;
  font-size: 28px;
`;
